(() => {
  if (customElements.get('header-drawer-wrapper')) {
    return;
  }

  class HeaderDrawerWrapper extends HTMLElement {
    constructor() {
      super();
      this.element = this.querySelector('a[href="/#product"]').addEventListener('click', (e) => {
        this.querySelector('details').classList.remove('menu-opening')
        this.querySelector('summary').setAttribute('aria-expanded', false)
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden-tablet');
      });
    }
  }

  customElements.define('header-drawer-wrapper', HeaderDrawerWrapper);
})();
